import React, { Component } from 'react';
import { Button, Table, Popconfirm, message, Modal, Popover, Icon } from 'antd';
import ExecuteMgrSider from './ExecuteMgrSider';
import API_URL from '../../common/url';
import { CasCadeOption, SelectOption } from './ViolationModal';
import StringUtil from '../../common/StringUtil';
import AjaxRequest from '../../common/AjaxRequest';
import AddModuleDefine from './AddModuleDefine';
import SetModuleDefineOption from './SetModuleDefineOption';
import SortList from '../common/SortList';

const confirm = Modal.confirm;

class Violation extends Component {
    state = {
        loading: false,
        dataList: [],
        crfDefineId: '',
        isRelative: true
    }

    loadData = () => {
        const { isRelative } = this.state;
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.execute.getCategoryTree}`,
            data: {
                typeName: isRelative ? 'Type_Violation' : 'Type_Nopatient_Violation',
                isDefine: 1,
            },
            dataType: 'json',
            doneResult: ( data => {
                    this.setState({
                        loading: false,
                        dataList: data.data.tableColumns,
                        crfDefineId: data.data.crfDefineId,
                    });
                }
            ),
        };
        AjaxRequest.sendRequest(options);
    };

    getColumns = () => {
        const { isRelative } = this.state;
        const columnNames = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
        }, {
            title: '字段名称',
            dataIndex: 'moduleDefineName',
            key: 'moduleDefineName',
        }, {
            title: '字段类型',
            dataIndex: 'criteriaDataType',
            key: 'criteriaDataType',
        }, {
            title: '填写方式',
            dataIndex: 'projectDefineWebType',
            key: 'projectDefineWebType',
        }, {
            title: '是否必填',
            dataIndex: 'moduleDefineIsRequired',
            key: 'moduleDefineIsRequired',
        }, {
            title: '可选项',
            dataIndex: 'options',
            key: 'options',
        }];

        columnNames.push({
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (text, record) => {
                const dis = record.projectDefineIsDefault == '1';
                const disabled = sessionStorage.invStatus == 'COMPLETED';
                let disOption = true;
                if (dis == false && (record.projectDefineWebType == '单选' || record.projectDefineWebType == '多选' || record.projectDefineWebType == '下拉框')){
                    disOption = false;
                }
                let deleteDis = dis == true || (dis == false && record.options) ? true : false;
                return (
                    <span>
                        <a disabled={disabled || dis} onClick={() => this.edit(record.moduleDefineId)}>修改</a>
                        <span className="ant-divider"/>
                        <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.del(record.moduleDefineId, 0)} okText="确定" cancelText="取消">
                            <a disabled={disabled || deleteDis}>删除</a>
                        </Popconfirm>
                        <span className="ant-divider"/>
                        {
                            record.moduleDefineName == '方案违背分类' ?   
                                isRelative ?
                                    <a onClick={() => this.setCasCade(record.moduleDefineCode)}>设置级联可选项</a>
                                :
                                    <a onClick={() => this.showSelectOption(record)}>设置可选项</a>
                            :  
                                disOption && (record.moduleDefineName != '方案违背等级') && (record.moduleDefineName != '是否属于重大事件') ?
                                    <a disabled={true}>设置可选项</a>
                                :
                                    <a onClick={() => this.setOption(record.moduleDefineId)}>设置可选项</a>
                        }
                    </span>
                );
            },
        });
        return columnNames;
    };

    getCriteriaDataTypeInfo = (criteriaDateType) => {
        if (criteriaDateType == 'DATE') {
            return '时间型'
        }
        if (criteriaDateType == 'NUMBER') {
            return '数值型';
        }
        return '文本型';
    };

    getWebTypeInfo = (dataType, webType, formatValue) => {
        if (dataType == 'NUMBER') {
            return '文本框(数字格式：' + (formatValue ? formatValue : '0') + ')';
        }
        if (dataType == 'DATE') {
            if (formatValue == 'YYYY-MM-DD HH:MI') {
                return '时间控件(年月日时分)';
            }
            if (formatValue == 'YYYY-MM') {
                return '时间控件(年月)';
            }
            return '时间控件(年月日)';
        }
        if (webType == 'RADIO') {
            return '单选';
        }
        if (webType == 'CHECKBOX') {
            return '多选';
        }
        if (webType == 'INPUT') {
            return '文本框';
        }
        if (webType == 'TEXTAREA') {
            return '文本域';
        }
        if (webType == 'SELECT') {
            return '下拉框';
        }
        return '未知格式';
    };

    handleModuleDefineAction = (value, confirm) => {
        if(confirm == null || confirm == undefined){
            confirm = 0;
        }
        const { crfDefineId } = this.state;
        if (value.moduleDefineId == 0) {
            const dataObj = {
                datas: [{...value}],
            };
            const options = {
                url: `${API_URL.execute.addExecuteDefine}`,
                data: {
                    investigationId: sessionStorage.invId,
                    typeName: 'Type_Violation',
                    crfDefineId,
                    confirm,
                    datas: JSON.stringify(dataObj),
                },
                method:'POST',
                dataType: 'json',
                doneResult: ( data => {
                    if(confirm == 0 && data.confirmError){
                        this.showConfirm(value, data.confirmError);
                    } else {
                        this.loadData();
                    }
                }),
                errorResult: (() => {
                    this.setState({ loading: false });
                }),
            };
            AjaxRequest.sendRequest(options);
        } else {
            const options = {
                url: `${API_URL.execute.updateExecuteDefine}`,
                data: {
                    moduleDefineId: value.moduleDefineId,
                    moduleDefineName: value.moduleDefineName,
                    typeName: 'Type_Violation',
                    projectDefineWebType: value.projectDefineWebType,
                    moduleDefineIsRequired: value.moduleDefineIsRequired,
                    formatValue: value.formatValue,
                },
                dataType: 'json',
                doneResult: (() => {
                    message.success("设置成功");
                    this.loadData();
                }),
                errorResult: (() => {
                    this.setState({ loading: false });
                }),
            };
            AjaxRequest.sendRequest(options);
        }
    };

    showConfirm = (value, content) => {
        const _this= this;
        confirm({
            title: '确认添加',
            content: content,
            onOk() {
                _this.handleModuleDefineAction(value, 1);
            },
            onCancel() {},
        });
    }

    handleModuleDefineOptionAction = (dataList, moduleDefineId) => {
        let str = '?';
        let idx = 0;
        dataList.map((item, i) => {
            if (!StringUtil.isNull(item.text)){
                if (idx > 0) {
                    str += '&';
                }
                str = str + "arrays[" + idx + "]=" + item.text;
                idx++;
            }
        });
        const url = `${API_URL.execute.updateExecuteDefineOption}` + str;

        const { isRelative } = this.state;
        const options = {
            url,
            data: {
                moduleDefineId,
                typeName: isRelative ? 'Type_Violation' : 'Type_Nopatient_Violation',
            },
            dataType: 'json',
            doneResult: ( data => {
                message.success("设置成功");
                this.loadData();
            }),
            errorResult: (() => {
                this.setState({ loading: false });
            }),
        };
        AjaxRequest.sendRequest(options);
    };

    getDataSource = () => {
        const resList = [];
        const {dataList} = this.state;
        let idx = 1;
        dataList.map((dataItem, i) => {
            if (dataItem.moduleDefineName != '录入者') {
                resList.push({
                    index: idx,
                    moduleDefineId: dataItem.moduleDefineId,
                    criteriaDefineId: dataItem.criteriaDefineId,
                    moduleDefineName: dataItem.moduleDefineName,
                    moduleDefineCode: dataItem.moduleDefineCode,
                    criteriaDataType: this.getCriteriaDataTypeInfo(dataItem.criteriaDataType),
                    projectDefineWebType: this.getWebTypeInfo(dataItem.criteriaDataType, dataItem.projectDefineWebType, dataItem.formatValue),
                    moduleDefineIsRequired: dataItem.moduleDefineIsRequired == '1' ? '是' : '否',
                    projectDefineIsDefault: dataItem.projectDefineIsDefault,
                    options: dataItem.moduleDefineConstraintValue ? StringUtil.replaceAll(dataItem.moduleDefineConstraintValue, '//', ';') : '',
                    visitMappingValues: dataItem.visitMappingValues,
                });
                idx++;
            }
        });
        return resList;
    };

    add = () => {
        this.addModuleDefineRef.show();
    }

    sort = () => {
        const {dataList} = this.state;
        const sortList = [];
        dataList.map(item => {
            if (item.moduleDefineName != '录入者'){
                sortList.push({
                    key: item.moduleDefineCode,
                    name: item.moduleDefineName,
                });
            }
        });
        this.sortListRef.show(sortList);
    }

    edit = id => {
        const {dataList} = this.state;
        dataList.map((dataItem, i) => {
            if (dataItem.moduleDefineId == id) {
                this.addModuleDefineRef.show(dataItem, 1);
            }
        });
    };

    del = (id, confirm) => {
        const options = {
            url: `${API_URL.execute.deleteExecuteDefine}`,
            data: {
                moduleDefineId: id,
                typeName: 'Type_Violation',
                confirm,
            },
            dataType: 'json',
            doneResult: ( data => {
                if(data.confirmError){
                    this.confirmDel(id, data.confirmError);
                } else {
                    this.loadData();
                }
            }),
        };
        AjaxRequest.sendRequest(options);
    };

    confirmDel = (id, confirmError) => {
        const _this = this;
        Modal.confirm({
          iconType: 'exclamation-circle',
          title: confirmError,
          onOk() {
              _this.del(id, 1);
          },
          onCancel() {
          },
      });
    }

    setOption = id => {
        const {dataList} = this.state;
        dataList.map((dataItem, i) => {
            if (dataItem.moduleDefineId == id) {
                this.setModuleDefineOptionRef.show(dataItem, 1);
            }
        });
    }

    showSelectOption = record => {
        this.SelectOptionRef.show({...record});
    }

    setCasCade = moduleDefineCode => {
        this.CasCadeOptionRef.show(moduleDefineCode);
    }

    handleBtnClick = () => {
        this.setState(prevState => ({
            isRelative: !prevState.isRelative
        }), () => {
            this.loadData();
        })
    }

    componentDidMount() {
        this.loadData();
    }

    render() {
        const { isRelative } = this.state;
        const { loading } = this.props;
        const { curRole, invStatus, investigationSiteName } = sessionStorage;
        const disabled = invStatus == 'COMPLETED';
        const isShow= !investigationSiteName && (curRole == 'PA'|| curRole == 'PM' || curRole == 'CTA');
        const contentNode = <span>
            一、与患者有关的违背<br/>
            1.点击“方案违背分类”的操作“设置级联可选项”，可以自行设置<br/>方案违背分类；<br/>
            2.一级/二级选项不能修改、删除；<br/>
            3.点击二级选项，点击添加操作，可以添加第三级选项，以此类<br/>推，最多添加至第六层；<br/>
            4.选中某级选项，点击修改操作，可以修改该选项；<br/>
            5.选中某级选项，点击删除操作，可以删除该选项（若该选项后<br/>还有层级，将一起删除）；<br/><br/>
            二、与患者无关的违背记录<br/>
            1.点击“方案违背分类”的操作“设置可选项”，可以补充设置方案<br/>违背分类；
        </span>
        return (
            <div className="content">
                <ExecuteMgrSider selectKey='violation' />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        {
                            isShow &&
                            <Popover placement="right" overlayClassName="propercent-pop" content={contentNode}>
                                <div style={{float: 'left'}}>
                                    <Icon type="info-circle" style={{color: '#5750c9', marginRight: 4}} />
                                    <a>配置说明</a>
                                </div>
                            </Popover>
                        }
                        <h2 className="title">方案违背</h2>
                    </div>
                    <div className="tab_flex" style={{margin: '20px 0'}}>
                        <a className={isRelative && "curr"} onClick={this.handleBtnClick} >与患者有关的违背</a>
                        <a className={!isRelative && "curr"} onClick={this.handleBtnClick} >与患者无关的违背</a>
                    </div>
                    <div className="filter-bar tar">
                        <Button type="primary" onClick={this.sort}>排序调整</Button>
                        <Button type="primary" disabled={disabled} onClick={this.add}>添加</Button>
                    </div>
                    <div className="main-content">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.moduleDefineId}
                            loading={loading}
                            pagination={false}
                        />
                    </div>
                </div>
                <CasCadeOption ref={el => this.CasCadeOptionRef = el }/>
                <AddModuleDefine
                    ref={el => this.addModuleDefineRef = el}
                    handleModuleDefineAction={this.handleModuleDefineAction}
                />
                <SetModuleDefineOption
                    ref={el => this.setModuleDefineOptionRef = el}
                    handleModuleDefineOptionAction={this.handleModuleDefineOptionAction}
                />
                <SortList
                    reload={this.loadData}
                    title='方案违背-排序调整'
                    data={{typeName: 'Type_Violation'}}
                    ref={el => this.sortListRef = el}
                    sortUrl={`${API_URL.execute.sortExecuteDefine}`}
                />
                <SelectOption
                    loadData={this.loadData}
                    ref={el => this.SelectOptionRef = el}
                />
            </div>
        );
    }
}

export default Violation;



// WEBPACK FOOTER //
// ./src/components/executeMgr/Violation.js